<div *ngFor="let app of applications">
  <app-doctors-station-unblock
    *ngIf="isStation && app.clientId === clientId"
    [clientId]="clientId"
  ></app-doctors-station-unblock>
  <app-dr-dish-unblock
    *ngIf="app.type === 'dr-dish' && app.clientId === clientId"
    [clientId]="clientId"
  ></app-dr-dish-unblock>
  <app-suguyaku-unblock
    *ngIf="app.type === 'suguyaku' && app.clientId === clientId"
    [clientId]="clientId"
  ></app-suguyaku-unblock>

  <app-doctors-next-unblock
    *ngIf="app.type === 'dnext' && app.clientId === clientId"
    [clientId]="clientId"
  ></app-doctors-next-unblock>
  <app-collabo-portal-unblock
    *ngIf="app.type === 'cportal' && app.clientId === clientId"
    [clientId]="clientId"
  ></app-collabo-portal-unblock>
  <app-sgzp-app2-unblock
    *ngIf="app.type === 'cportal-sgzp-app2' && app.clientId === clientId"
    [clientId]="clientId"
  ></app-sgzp-app2-unblock>
  <app-sas-station-unblock
    *ngIf="app.type === 'sas-station' && app.clientId === clientId"
    [clientId]="clientId"
  ></app-sas-station-unblock>
</div>
<app-dynamic-component-host #dynamicComponentHost></app-dynamic-component-host>
